import { PageTypeEnum } from 'common/enums/PageTypeEnum'

export const pageActionsExclusions: PageTypeEnum[] = [
  PageTypeEnum.NotFound,
  PageTypeEnum.WebsiteLogin,
  PageTypeEnum.WebsiteSearch,
]
